import React from 'react';

import {Table} from 'notebook/tables/constants/TableConstants';
import {EvaluatedTable} from 'notebook/tables/excess/Evaluator';
import APIUtil from 'util/APIUtil';

import {extractTableDataForSuggestions, GetTableDataFn} from './extractTableDataForSuggestions';
import SuggestedPlotsDropdown from './SuggestedPlotsDropdown';
import {arePlotSuggestionsSupportedSync} from './suggestPlotsUtils';

interface PlainTableSuggestedPlotsButtonProps {
  fileId: string;
  table: Table;
  computedTable: EvaluatedTable;
}

export default function PlainTableSuggestedPlotsButton({
  fileId,
  table,
  computedTable,
}: PlainTableSuggestedPlotsButtonProps): JSX.Element | null {
  if (!arePlotSuggestionsSupportedSync()) {
    return null;
  }
  if (!APIUtil.isEntry(fileId) && !APIUtil.isDocument(fileId)) {
    return null;
  }

  const getTableData: GetTableDataFn = () => extractTableDataForSuggestions(table, computedTable);

  return <SuggestedPlotsDropdown entryId={fileId} tableName={table.name} getTableData={getTableData} />;
}
